//
// locales/vanilla/kk.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/kk.json';
import localeData from 'react-intl/locale-data/kk.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
